export default __webpack_public_path__ + "static/media/78938fef0b3d7b88ebdc9ffd92b01170.svg";